import { Box, useColorModeValue } from '@chakra-ui/react';
import { components } from '@lib/docs/components';
import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote';
import { HeadingItem } from '@lib/docs/plugins/remark-plugin-headings/remark-plugin-headings';

type MDXContainerProps = {
  mdx: MDXRemoteSerializeResult & {
    headings: HeadingItem[];
    editLink: string;
    lastUpdated: string | null;
  };
};

export function MDXContainer({ mdx }: MDXContainerProps) {
  const codeBgColor = useColorModeValue('gray.100', '#282C34');

  const lastUpdated = mdx.lastUpdated
    ? new Date(mdx.lastUpdated).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : null;

  return (
    <Box
      sx={{
        '& :not(pre) > code': {
          bgColor: codeBgColor,
          border: '1px solid var(--borderColor)',
          rounded: 'lg',
          px: 1.5,
          py: 1,
          fontSize: '0.75em',
          whiteSpace: ['normal', 'nowrap']
        }
      }}
    >
      <MDXRemote {...mdx} components={components} />

      {lastUpdated && (
        <p className="pt-4 text-sm text-black/60 dark:text-white/60">
          Last updated on {lastUpdated}
        </p>
      )}
    </Box>
  );
}
